module.exports = __webpack_public_path__ + "static/media/classification.66a621f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classification.png
// module id = 292
// module chunks = 38